
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getVehicleWatchlist = (sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Watchlists/GetVehicleWatchlist`,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addMemberWatchlist = (auctionTierMemberId, auctionTierId, auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.put(`${Environment.apiUrl}/Watchlists/AddMemberWatchlist/${auctionTierMemberId}/${auctionTierId}/${auctionId}`, null, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const removeMemberWatchlist = (auctionTierMemberId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.delete(`${Environment.apiUrl}/Watchlists/RemoveMemberWatchlist/` + auctionTierMemberId, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const WatchlistsService =
{
	getVehicleWatchlist,
	addMemberWatchlist,
	removeMemberWatchlist,
}

export default WatchlistsService
